import { usePizzaEvaluationContext } from "@/context/pizza-evaluation-context";
import { usePizzaContext } from "@/context/pizza-context";
import { useLocalization } from "@/context/localization-context";
import SelectedProduct from "@/orders/selected-product";
import Pizzas from "@/pizzas/pizzas";
import { COMPONENT_ERROR_SEARCH_PARAMS } from "@/pizzas/component-errors";
import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";

const parseDateParam = (value: string | null) => {
  if (!value) return undefined;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date;
};

export default function Page() {
  const { pizzaId } = useParams();
  const { t } = useLocalization();
  const [searchParams, setSearchParams] = useSearchParams();
  const { setSelectedPizzaId, setApplyRoi } = usePizzaEvaluationContext();
  const {
    resetFilters,
    setComponentErrorFilter,
    setCaptureAtFilterStart,
    setCaptureAtFilterEnd,
  } = usePizzaContext();

  useEffect(() => {
    setSelectedPizzaId(pizzaId || null);
  }, [pizzaId, setSelectedPizzaId]);

  // A link from the dashboard ("Score by component") replaces the list filters
  // with the component error and its period; the params are dropped afterwards
  // so that the filters stay editable.
  useEffect(() => {
    const component = searchParams.get(COMPONENT_ERROR_SEARCH_PARAMS.component);
    if (!component) return;

    resetFilters();
    setComponentErrorFilter(component);
    setCaptureAtFilterStart(
      parseDateParam(searchParams.get(COMPONENT_ERROR_SEARCH_PARAMS.from)),
    );
    setCaptureAtFilterEnd(
      parseDateParam(searchParams.get(COMPONENT_ERROR_SEARCH_PARAMS.to)),
    );
    setSearchParams({}, { replace: true });
  }, [
    searchParams,
    setSearchParams,
    resetFilters,
    setComponentErrorFilter,
    setCaptureAtFilterStart,
    setCaptureAtFilterEnd,
  ]);

  useEffect(() => {
    setApplyRoi(true);
  }, []);

  return (
    <div className="app-layout flex flex-col gap-4 p-3 sm:p-4">
      {pizzaId != null && <SelectedProduct navigation="pizzas" swipeNavigation />}
      {/* from tablets up the list is one screen tall: toolbar and paging stay, the rows scroll inside */}
      <section
        className="flex flex-col rounded-xl border bg-card p-3 sm:p-4 md:h-[calc(100svh-5rem)] md:min-h-[30rem]"
        aria-label={t("common.pizzas")}
      >
        <Pizzas
          getLink={(path) => `/pizzas/${path}`}
          cursor={pizzaId}
          rows={!pizzaId ? 5 : 10}
          title={pizzaId != null ? t("pizzas.page.allPizzas") : t("common.pizzas")}
        />
      </section>
    </div>
  );
}
